import createDataContext from './createDataContext'

interface StateType {
    component: { component, props },
    selectedPart,
    filters: { parts, car, prDetails },
    vendorSubComponent: { component, props },
    miscModal: { visibility: boolean, coords: { x: number, y: number }, children, disable?: boolean },
    workshop: { id: string, entityName: string, entityDisplayName: string, nonSortingEntities: any[] },
    purchaser: { id: string, username: string, tag: string },
    openMarketConfirmParts: { type: string|null },
    workshopList: { id: string, entityName: string, entityDisplayName: string, nonSortingEntities: any[], defaultReceiveLocation: any }[],
    mainHeaderLoading: boolean,
    confirmationPendingData: any,
    purchaserList: { id: string, username: string, tag: string }[],
    invoicingPendingData: any,
    carBasedData: any,
    receivingPendingData: any,
    purchaseRequestDataForACar: any,
    byCarReceivingDetails: any,
    unconfirmedPartsData: any,
    purchaserGlobalSearch: (search: string) => void,
    globalSearch: string,
    notifications: any,
    nonPurchaserUserList:any[],
    selectedNonPurchaserUser: any,
    purchaserSuccess:boolean
}

interface ActionType {
    payload: any,
    type: string
}

const initialState: StateType = {
    component: { component: null, props: {} },
    selectedPart: {},
    filters: { parts: {}, car: {}, prDetails: {} },
    vendorSubComponent: { component: null, props: {} },
    miscModal: { visibility: false, coords: { x: -1, y: -1 }, children: null, disable: false },
    workshop: { id: '', entityName: '', entityDisplayName: '', nonSortingEntities: [] },
    purchaser: { id: '', username: '', tag: '' },
    openMarketConfirmParts: { type: null },
    workshopList: [],
    mainHeaderLoading: false,
    confirmationPendingData: {},
    purchaserList: [],
    invoicingPendingData: {},
    carBasedData: {},
    receivingPendingData: {},
    purchaseRequestDataForACar: {},
    byCarReceivingDetails: {},
    unconfirmedPartsData: {},
    purchaserGlobalSearch: () => {},
    globalSearch: '',
    notifications: {},
    selectedNonPurchaserUser:'',
    nonPurchaserUserList:[],
    purchaserSuccess: false
}

const reducer = (state, action: ActionType) => {
    switch(action.type)
    {
        case 'setFilters': return { ...state, filters: action.payload }

        case 'setSelectedPart': return { ...state, selectedPart: action.payload }

        case 'setNonPurchaserList': return { ...state, nonPurchaserUserList: action.payload }

        case 'selectedNonPurchaserUser': return { ...state, selectedNonPurchaserUser: action.payload }

        case 'setComponent': return { ...state, component: { component: action.payload.Component, props: action.payload.props } }

        case 'setVendorSubComponent': return { ...state, vendorSubComponent: { component: action.payload.Component, props: action.payload.props } }

        case 'setMiscModal': return { ...state, miscModal: action.payload }

        case 'setWorkshop': return { ...state, workshop: action.payload }

        case 'setPurchaserSuccess': return { ...state, purchaserSuccess: action.payload }

        case 'setPurchaser': return { ...state, purchaser: action.payload }

        case 'setOpenMarketConfirmParts': return { ...state, openMarketConfirmParts: action.payload }

        case 'setWorkshopList': return { ...state, workshopList: action.payload }

        case 'setMainHeaderLoading': return { ...state, mainHeaderLoading: action.payload }

        case 'setConfirmationPendingData': return { ...state, confirmationPendingData: action.payload }

        case 'setPurchaserList': return { ...state, purchaserList: action.payload }
        
        case 'setInvoicingPendingData': return { ...state, invoicingPendingData: action.payload }

        case 'setCarBasedData': return { ...state, carBasedData: action.payload }

        case 'setReceivingPendingData': return { ...state, receivingPendingData: action.payload }

        case 'getRequest': return { ...state, purchaseRequestDataForACar: action.payload }

        case 'getByCarReceivingDetails': return { ...state, byCarReceivingDetails: action.payload }

        case 'getUnconfirmedPartsData': return { ...state, unconfirmedPartsData: action.payload }

        case 'setPurchaserGlobalSearch': return { ...state, purchaserGlobalSearch: action.payload }

        case 'setGlobalSearch': return { ...state, globalSearch: action.payload }

        case 'setNotification': return { ...state, notifications: action.payload }

        case 'logout': return initialState

        default: return state
    }

}

const getAllEntities = dispatch => {

    return async (variables, getAllEntities, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllEntities({ variables })

            !!callback ? callback?.(response.data?.getAllEntities) : null

        } catch(e)
        {
            console.log('GET ALL ENTITIES ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }
    
}

const setGlobalSearch = dispatch => {

    return (search: string) => {

        dispatch({ type: 'setGlobalSearch', payload: search })

    }

}

const setPurchaserGlobalSearch = dispatch => {

    return (purchaserGlobalSearch) => {

        dispatch({ type: 'setPurchaserGlobalSearch', payload: purchaserGlobalSearch })

    }

}

const getConfirmationPendingOpenMarketData = dispatch => {

    return async (variables, getConfirmationPendingOpenMarketData, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            
            const response = await getConfirmationPendingOpenMarketData({ variables })

            !!callback ? callback?.(response.data?.getAllPurchaseListItemsForPurchaserGroupByVendorsOpenMarket) : null

        } catch(e)
        {
            console.log('GET CONFIRMATION PENDING OPEN MARKET DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }
    
}

const confirmPartsForPurchaseRequest = dispatch => {

    return async (variables, confirmPartsForPurchaseRequest, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await confirmPartsForPurchaseRequest({ variables })

            !!callback ? callback?.(response.data) : null

        } catch(e)
        {
            console.log('CONFIRM PARTS FOR PURCHASE REQUEST ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getUnconfirmedPartsData = dispatch => {

    return async (variables, getUnconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getUnconfirmedParts({ variables })

            dispatch({ type: 'getUnconfirmedPartsData', payload: response.data?.getAllPurchaseListsForVendor })

            !!callback ? callback?.(response.data?.getAllPurchaseListsForVendor) : null

        } catch(e)
        {
            console.log('GET UNCONFIRMED PARTS DATA ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getByCarReceivingDetails = dispatch => {

    return async (variables, getByCarReceivingDetails, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getByCarReceivingDetails({ variables })

            dispatch({ type: 'getByCarReceivingDetails', payload: response.data?.getRequestItemToInventoryActivitiesForRequest })

            !!callback ? callback?.(response.data?.getRequestItemToInventoryActivitiesForRequest) : null

        } catch(e)
        {
            console.log('GET BY CAR RECEIVING DETAILS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getRequest = dispatch => {

    return async (variables, getRequest, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getRequest({ variables })

            dispatch({ type: 'getRequest', payload: response.data?.getRequest })

            !!callback ? callback?.(response.data?.getRequest) : null

        } catch(e)
        {
            console.log('GET REQUEST ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setReceivingPendingData = dispatch => {

    return async (variables, getPurchaseRequestsByVendor, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getPurchaseRequestsByVendor({ variables })

            dispatch({ type: 'setReceivingPendingData', payload: response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors })

            !!callback ? callback?.(response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors) : null

        } catch(e)
        {
            console.log('RECEIVING PENDING ERROR', e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setCarBasedData = dispatch => {

    return async (variables, getAllRequests, callback?, err_callback?: (message) => void) => {

        try
        {

            const response = await getAllRequests({ variables })

            dispatch({ type: 'setCarBasedData', payload: response.data?.getAllRequests })

            !!callback ? callback?.(response.data?.getAllRequests) : null

        } catch(e)
        {
            console.log(e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setInvoicingPendingData = dispatch => {

    return async (variables, getPurchaseRequestsByVendor, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getPurchaseRequestsByVendor({ variables })

            dispatch({ type: 'setInvoicingPendingData', payload: response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors })

            !!callback ? callback?.(response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors) : null

        } catch(e)
        {
            console.log('INVOICING PENDING ERROR', e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setPurchaserList = dispatch => {

    return async (variables, getPurchasers, callback?, err_callback?: (message) => void) => {

        try
        {
            const response = await getPurchasers({ variables })

            dispatch({ type: 'setPurchaserList', payload: response.data?.getAllPurchasersForUser?.map(val => ({ id: val?.id, username: val?.user?.username, tag: val?.tag })) })

            !!callback ? callback?.(response.data?.getAllPurchasersForUser?.map(val => ({ id: val?.id, username: val?.user?.username, tag: val?.tag }))) : null

        } catch(e)
        {
            console.log(e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setConfirmationPendingData = dispatch => {

    return async (variables, getPurchaseRequestsByVendor, callback?: (data) => void, err_callback?: (message) => void) => {

        try
        {
            const response = await getPurchaseRequestsByVendor({ variables })

            dispatch({ type: 'setConfirmationPendingData', payload: response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors })
            
            !!callback ? callback?.(response.data?.getAllPurchaseListItemsForPurchaserGroupByVendors) : null

        } catch(e)
        {
            console.log(e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setMainHeaderLoading = dispatch => {

    return (loading: boolean, callback?) => {

        dispatch({ type: 'setMainHeaderLoading', payload: loading })

        !!callback ? callback?.() : null

    }

}

const setWorkshopList = dispatch => {

    return async (getEntities, callback?, err_callback?: (message) => void) => {
        try
        {

            const response = await getEntities()

            console.log('RESPONSE', response.data)

            dispatch({ type: 'setWorkshopList', payload: response.data?.getEntities?.filter?.(val => (val?.nonSortingEntities?.length > 0))?.map(val => ({ id: val?.id, entityName: val?.entityName, entityDisplayName: val?.entityDisplayName, nonSortingEntities: val?.nonSortingEntities, defaultReceiveLocation: val?.defaultReceiveLocation })) })

            !!callback ? callback?.(response.data?.getEntities?.filter?.(val => (val?.nonSortingEntities?.length > 0))?.map(val => ({ id: val?.id, entityName: val?.entityName, entityDisplayName: val?.entityDisplayName, nonSortingEntities: val?.nonSortingEntities, defaultReceiveLocation: val?.defaultReceiveLocation }))) : null

        } catch(e)
        {
            console.log(e)
            err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setOpenMarketConfirmParts = dispatch => {

    return (data, callback) => {

        dispatch({ type: 'setOpenMarketConfirmParts', payload: data })

        callback?.()

    }

}

const setPurchaser = dispatch => {

    return (purchaserData, callback) => {

        localStorage.setItem('purchaserId', purchaserData?.id)
        localStorage.setItem('purchaserTag', purchaserData?.tag)
        localStorage.setItem('purchaserUsername', purchaserData?.username)

        dispatch({ type: 'setPurchaser', payload: purchaserData })

        callback && callback()
    }
}

const setWorkshop = dispatch => {

    return (workshopData, callback) => {

        localStorage.setItem('default_entity_id', workshopData?.id)
        localStorage.setItem('default_receive_location_id', workshopData?.defaultReceiveLocation?.id)

        dispatch({ type: 'setWorkshop', payload: workshopData })

        callback && callback()
    }

}

const setPurchaserSuccess = dispatch => {

    return (data) => {
        dispatch({ type: 'setPurchaserSuccess', payload: data })

    }

}



const getNotifications = dispatch => {

    return async (variables, getNotificationMutation, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {

            const response = await getNotificationMutation({ variables })

            dispatch({ type: 'setNotification', payload: response.data?.getNotifications })

            !!callback ? callback?.(response.data?.getNotifications) : null

        } catch(e)
        {
            console.log('GET NOTIFICATIONS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const readNotifications = dispatch => {

    return async (variables, readNotificationMutation, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            const response = await readNotificationMutation({ variables })

            !!callback ? callback?.(response.data?.markNotificationReadStatus) : null

        } catch(e)
        {
            console.log('READ NOTIFICATIONS ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const getAlternatePart = dispatch => {

    return async (variables, getAlternatePartMutation, callback?: (data?) => void, err_callback?: (message) => void) => {

        try
        {
            const response = await getAlternatePartMutation({ variables })

            !!callback ? callback?.(response.data?.getAlternatePartRequest) : null

        } catch(e)
        {
            console.log('GET ALTERNATE PART ERROR', e)
            !!err_callback ? err_callback?.(e?.message) : null
        }

    }

}

const setMiscModal = dispatch => {

    return (visibility, coords, children, disable = false) => {
        dispatch({ type: 'setMiscModal', payload: { visibility, coords, children, disable } })
    }
}

const setVendorSubComponent = dispatch => {

    return (Component, props) => {
        dispatch({ type: 'setVendorSubComponent', payload: { Component, props } })
    }

}

const setFilters = dispatch => {

    return (partFilters, carFilters, prDetailsFilters, callback) => {
        dispatch({ type: 'setFilters', payload: { parts: partFilters, car: carFilters, prDetails: prDetailsFilters } })

        callback && callback()
    }

}

const setSelectedPart = dispatch => {

    return (part, callback) => {
        dispatch({ type: 'setSelectedPart', payload: part })

        callback && callback()
    }

}

const setNonPurchaserList = dispatch => {
    return (part, callback) => {
        dispatch({ type: 'setNonPurchaserList', payload: part })
        callback && callback()
    }
}

const setSelectedNonPurchaseUser = dispatch => {
    return (part) => {
        dispatch({ type: 'selectedNonPurchaserUser', payload: part })
    }
}

const setComponent = dispatch => {

    return (Component, props) => {
        console.log(props)
        dispatch({ type: 'setComponent', payload: { Component, props } })
    }

}

const logout = dispatch => {

    return () => {
        dispatch({ type: 'logout', payload: {} })
    }

}

export interface PurchaserInterface {
    state: StateType,
    setFilters: (partFilters, carFilters, prDetailsFilters, callback) => void,
    setSelectedPart: (part) => void,
    setComponent: (Component, props) => void,
    setVendorSubComponent: (Component, props) => void,
    setMiscModal: (visibility: boolean, coords: { x: number, y: number }, children, disable?: boolean) => void,
    setWorkshop: (workshopData, callback: () => void) => void,
    setPurchaserSuccess: (purchaserSuccessData) => void,
    setPurchaser: (purchaserData, callback: () => void) => void,
    setOpenMarketConfirmParts: (data, callback: () => void) => void,
    setWorkshopList: (getEntities, callback?, err_callback?: (message) => void) => Promise<void>,
    setMainHeaderLoading: (loading: boolean, callback?) => void,
    setConfirmationPendingData: (variables, getPurchaseRequestsByVendor, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>,
    setPurchaserList: (variables, getPurchasers, callback?, err_callback?: (message) => void) => Promise<void>,
    setInvoicingPendingData: (variables, getPurchaseRequestsByVendor, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>,
    setCarBasedData: (variables, getAllRequests, callback?, err_callback?: (message) => void) => Promise<void>,
    setReceivingPendingData: (variables, getPurchaseRequestsByVendor, callback?: (data) => void, err_callback?: (message) => void) => Promise<void>,
    getRequest: (variables, getRequest, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getByCarReceivingDetails: (variables, getByCarReceivingDetails, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getUnconfirmedPartsData: (variables, getUnconfirmedParts, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    confirmPartsForPurchaseRequest: (variables, confirmPartsForPurchaseRequest, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getConfirmationPendingOpenMarketData: (variables, getConfirmationPendingOpenMarketData, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    setPurchaserGlobalSearch: (purchaserGlobalSearch) => void,
    setGlobalSearch: (search: string) => void,
    setSelectedNonPurchaseUser: (string)=>void,
    getAllEntities: (variables, getAllEntities, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getNotifications: (variables, getNotificationMutation, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    readNotifications: (variables, readNotificationMutation, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    getAlternatePart: (variables, getAlternatePartMutation, callback?: (data?) => void, err_callback?: (message) => void) => Promise<void>,
    setNonPurchaserList:(search: any[]) => void,
    logout: () => void
}

export const { Context: PurchaserContext, Provider: PurchaserProvider } = createDataContext(
    reducer,
    { setComponent, 
        setSelectedPart, 
        setFilters, 
        setVendorSubComponent, 
        setMiscModal, 
        setWorkshop, 
        setPurchaserSuccess,
        setPurchaser, 
        setOpenMarketConfirmParts, 
        setWorkshopList, 
        setMainHeaderLoading, 
        setConfirmationPendingData, 
        setPurchaserList, 
        setInvoicingPendingData, 
        setCarBasedData, 
        setReceivingPendingData, 
        getRequest, 
        getByCarReceivingDetails, 
        getUnconfirmedPartsData, 
        confirmPartsForPurchaseRequest, 
        getConfirmationPendingOpenMarketData, 
        setPurchaserGlobalSearch, 
        setGlobalSearch, 
        getAllEntities, 
        logout, 
        getNotifications, 
        readNotifications, 
        getAlternatePart, 
        setNonPurchaserList, 
        setSelectedNonPurchaseUser 
    },
    initialState
)
